<template>
    <div class="introduction">
        <div class="top-wrapper">
            <img class="top-img" src="@/assets/imgs/introduction.png" alt="">
            <div class="mask">
                <img class="m-img" src="@/assets/imgs/id-icon.png" alt="">
                <div class="m-title">体验720°数字博物馆</div>
                <div class="btn cursor-pointer" @click="handleClick()">开 始 体 验</div>
            </div>
        </div>
        <div class="container">
            <div class="content">
                <div class="left">
                    <div class="title">【博物馆简介】</div>
                    <div class="desc">顺昌县博物馆位于城东塔山路，交通便利，环境优美，是顺昌县地标性建筑，同时，兼具城市客厅功能。顺昌县博物馆整体建筑外观，犹如一艘扬帆巨轮，依偎在富屯溪畔，象征着顺昌县在各级领导的关心支持下扬帆奋进。
                    </div>
                </div>
                <div class="right">
                    <img class="content-img-1" src="@/assets/imgs/update/jj1.png" alt="">
                </div>
            </div>
            <div class="content">
                <div class="left">
                    <img class="content-img-2" src="@/assets/imgs/update/jj2.png" alt="">
                </div>
                <div class="right">
                    <div class="desc">
                        <p>博物馆主体建筑于2019年1月开工，2021年12月通过竣工验收。主体建筑占地6164.5㎡，建筑面积10138.2㎡。建筑分为东、中、西三个部分。东侧为博物馆的主要功能区域，设有固定展厅2个；临时展厅1个、交流展厅1个，以及办公、学术报告、文化休闲、文创运营等区域。中部连廊主要设计为学术讲座、文旅推介、以及研学科普等社教功能区域。西侧为一二层通透设计，主要用于非遗展示、青少年活动、文创开发等。
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { MessageBox } from 'element-ui';

const handleClick = () => {
    // window.location.href='https://www.qofo360.com/jinlin/sxbwg/index.html'
    // window.open('https://www.qofo360.com/jinlin/bsfjq/index.html', '_blank');
    MessageBox.alert('正在建设中～', '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        showConfirmButton: false
    });

};
</script>

<style lang="scss" scoped>
.introduction {
    .top-wrapper{
        position: relative;
        .mask{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,.5);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .m-title{
                font-family:sy-font,serif;
                font-weight:700;
                color: rgba(255, 255, 255, 0.60);
                font-size:53px;
                margin-top: 37px;
            }
            .m-img{
                width: 117px;
                height: 117px;
            }
            .btn{
                width:336px;
                height:94px;
                border: 3px solid rgba(255, 255, 255, 0.54);
                border-radius:48px;
                text-align: center;
                line-height: 94px;
                margin-top: 35px;
                font-weight:700;
                color:#ffffff;
                font-size:38px;
            }
        }
    }
    .top-img {
        width: 100%;
    }
    .container{
        margin-top: 131px;
        margin-bottom: 217px;
    }
    .content{
        margin-bottom: 65px;
        display: flex;
        justify-content: space-between;
        line-height:36px;
        .left{
            width: 554px;
            .title{
                font-family:sy-font,serif;
                font-weight:700;
                color:#1c1c1c;
                font-size:31px;
                margin-left: -18px;
            }

        }
        .right{
            width: 474px;
        }
        .desc{
            width: 100%;
            margin-top: 50px;
            font-family:Source Han Sans CN;
            color: rgba(28, 28, 28, 0.5);
            font-size:16px;
            //text-indent: 30px;
            text-align: justify;
            .m-b-15{
                margin-bottom: 15px;
            }
        }
        .content-img-1{
            width: 474px;
        }
        .content-img-2{
            width: 554px;
            margin-top: 50px;
        }
    }
}
</style>
